import JONAS_EXT_1 from "./JONAS_EXT_1";
export default {
  JONAS_EXT_1,
};
